export default __webpack_public_path__ + "static/media/opensans-600.043771c9.ttf";